const API_BASE_URL = `${(
  process.env.REACT_APP_API_URL ||
  'https://backend-clinical-intake.dizzaroo.com'
).replace(/\/$/, '')}/api`;

export const API_ENDPOINTS = {
  projects: {
    create: `${API_BASE_URL}/projects`,
    get: (id) => `${API_BASE_URL}/projects/${id}`,
    list: `${API_BASE_URL}/projects`,
    update: (id) => `${API_BASE_URL}/projects/${id}`,
    delete: (id) => `${API_BASE_URL}/projects/${id}`,
    checkUnique: ({ name, studyId, trialAcronym, sponsorProtocolIdentifier }) => {
      const params = new URLSearchParams();
      const acronym = trialAcronym ?? name;
      const protocolId = sponsorProtocolIdentifier ?? studyId;
      if (acronym) params.append('trialAcronym', acronym);
      if (protocolId) params.append('sponsorProtocolIdentifier', protocolId);
      return `${API_BASE_URL}/projects/check-unique?${params.toString()}`;
    }
  },

  documentExport: {
    emailProtocolPdf: `${API_BASE_URL}/export/email-protocol-pdf`,
  },
  styleCompliance: {
    lintSection: `${API_BASE_URL}/style-compliance/lint-section`,
    lintDocument: `${API_BASE_URL}/style-compliance/lint-document`,
    applyAutofix: `${API_BASE_URL}/style-compliance/apply-autofix`,
  },

  documents: {
    upload: `${API_BASE_URL}/documents/upload`,
    download: (filename) => `${API_BASE_URL}/documents/download/${filename}`,
    files: `${API_BASE_URL}/documents`
  },
  ai: {
    parseDocuments: `${API_BASE_URL}/ai/parse-documents`,
    validateDocuments: `${API_BASE_URL}/ai/validate-documents`,
    validateDocumentsConsistency: `${API_BASE_URL}/ai/validate-documents-consistency`,
    autoPopulateAdminAndTrialSchema: `${API_BASE_URL}/ai/auto-populate-admin-and-trial-schema`,
    processSourceDocuments: `${API_BASE_URL}/ai/process-source-documents`,
    sourceDocumentJobs: `${API_BASE_URL}/ai/source-documents/jobs`,
    sourceDocumentJobStatus: (jobId) => `${API_BASE_URL}/ai/source-documents/jobs/${jobId}`,
    summarizeDocument: `${API_BASE_URL}/ai/summarize-document`,
    mapDocumentToIntakeSections: `${API_BASE_URL}/ai/map-document-to-intake-sections`,
    mapDocumentsToIntakeSections: `${API_BASE_URL}/ai/map-documents-to-intake-sections`,
    generateSoA: `${API_BASE_URL}/ai/generate-soa`,
    generateBackgroundInfo: `${API_BASE_URL}/ai/generate-background-info`,
    generateOfficialTitle: `${API_BASE_URL}/ai/generate-official-title`,
    section10Approach1: `${API_BASE_URL}/ai/section10-approach1`,
    section10Approach2: `${API_BASE_URL}/ai/section10-approach2`,
    section10Approach3: `${API_BASE_URL}/ai/section10-approach3`,
    section10Approach4: `${API_BASE_URL}/ai/section10-approach4`,
    generateSectionWithApproach: `${API_BASE_URL}/ai/generate-section-with-approach`,
  },
  adk: {
    templateLanguageReview: `${API_BASE_URL}/adk/template-language/review`,
  },
  clinicalIntake: {
    base: `${API_BASE_URL}/clinical-intake`,
    submit: `${API_BASE_URL}/clinical-intake/submit`,
    get: (id) => `${API_BASE_URL}/clinical-intake/${id}`,
    list: `${API_BASE_URL}/clinical-intake`,
    latest: `${API_BASE_URL}/clinical-intake/latest`,
    //latestWithTrialSchema: `${API_BASE_URL}/clinical-intake/latest-with-trial-schema`,
    latestWithTrialSchema: `${API_BASE_URL}/clinical-intake/latest-with-trial-schema`,
    markWorkflowComplete: `${API_BASE_URL}/clinical-intake/mark-workflow-complete`,
    markDocumentInitiated: `${API_BASE_URL}/clinical-intake/mark-document-initiated`,
    unlock: (projectId) => `${API_BASE_URL}/clinical-intake/unlock/${projectId}`,
    lock: (projectId) => `${API_BASE_URL}/clinical-intake/lock/${projectId}`,
    detectChanges: (projectId) => `${API_BASE_URL}/clinical-intake/detect-changes/${projectId}`,
    acknowledgeChanges: (projectId) => `${API_BASE_URL}/clinical-intake/acknowledge-changes/${projectId}`,
    appendixExtractUpload: `${API_BASE_URL}/clinical-intake/appendices/extract-upload`,
    //markWorkflowComplete: `${API_BASE_URL}/clinical-intake/mark-workflow-complete`
  },
  icf: {
    download: (id) => `${API_BASE_URL}/icf/download/${id}`,
  },
  sap: {
    download: (id) => `${API_BASE_URL}/sap/download/${id}`,
  },
  sapIntake: {
    latest: `${API_BASE_URL}/study-protocols/sap-intake/latest`,
    autoPopulateFromProtocol: `${API_BASE_URL}/study-protocols/sap-intake/auto-populate-from-protocol`,

  },
  templateLanguage: `${API_BASE_URL}/template-language`,
  studyRegistration: `${API_BASE_URL}/study-registration`,
  studyTeam: `${API_BASE_URL}/study-team`,
  auditLogs: `${API_BASE_URL}/audit-logs`,
  documentAuditLog: (documentId) => `${API_BASE_URL}/documents/${documentId}/audit-log`,
  usersDirectory: `${API_BASE_URL}/users/directory`,
  pinnedStudies: {
    list: `${API_BASE_URL}/users/me/pinned-studies`,
    pin: (projectId) => `${API_BASE_URL}/users/me/pinned-studies/${projectId}`,
    unpin: (projectId) => `${API_BASE_URL}/users/me/pinned-studies/${projectId}`,
  },
  scheduleOfActivities: {
    generate: `${API_BASE_URL}/schedule-of-activities/generate`,
    save: `${API_BASE_URL}/schedule-of-activities/save`,
    get: (protocolId) => `${API_BASE_URL}/schedule-of-activities/${protocolId}`,
    exportExcel: (protocolId) => `${API_BASE_URL}/schedule-of-activities/${protocolId}/export-excel`,
    importExcel: (protocolId) => `${API_BASE_URL}/schedule-of-activities/${protocolId}/import-excel`
  },
  s9: {
    chat: `${API_BASE_URL}/s9/chat`,
    resumeEditing: `${API_BASE_URL}/s9/resume-editing`,
    resetWorkspace: `${API_BASE_URL}/s9/reset-workspace`,
    workspace: `${API_BASE_URL}/s9/workspace`,
    publish: `${API_BASE_URL}/s9/publish`,
    versions: `${API_BASE_URL}/s9/versions`,
    version: (versionNumber) => `${API_BASE_URL}/s9/versions/${versionNumber}`,
    rollback: (versionNumber) => `${API_BASE_URL}/s9/versions/${versionNumber}/rollback`,
    latest: `${API_BASE_URL}/s9/latest`,
    pushToDataPlatform: `${API_BASE_URL}/s9/push-to-data-platform`,
  },
  policyRulebook: {
    files: (projectId) => `${API_BASE_URL}/policy-rulebook/${projectId}/files`,
    upload: `${API_BASE_URL}/policy-rulebook/upload`,
    delete: (fileId) => `${API_BASE_URL}/policy-rulebook/files/${fileId}`,
    download: (fileId) => `${API_BASE_URL}/policy-rulebook/files/${fileId}/download`,
  },
  workflows: {
    list: `${API_BASE_URL}/workflows`,
    getByWorkflowId: (workflowId) => `${API_BASE_URL}/workflows/workflow/${workflowId}`,
    getByDocumentId: (documentId) => `${API_BASE_URL}/workflows/${documentId}`,
    getWorkflowState: (documentId) => `${API_BASE_URL}/workflows/${documentId}/workflow`,
    create: `${API_BASE_URL}/workflows/workflow/create`,
    sendForCoAuthoring: (documentId) => `${API_BASE_URL}/workflows/${documentId}/workflow/co-authoring`,
    sendForReview: (documentId) => `${API_BASE_URL}/workflows/${documentId}/workflow/review`,
    requestAIUpdate: (documentId) => `${API_BASE_URL}/workflows/${documentId}/workflow/ai-update`,
    approve: (documentId) => `${API_BASE_URL}/workflows/${documentId}/workflow/approve`,
    getComments: (documentId) => `${API_BASE_URL}/workflows/${documentId}/comments`,
    addComment: (documentId) => `${API_BASE_URL}/workflows/${documentId}/comments`,
    addReply: (documentId, commentId) => `${API_BASE_URL}/workflows/${documentId}/comments/${commentId}/replies`,
    getVersions: (documentId) => `${API_BASE_URL}/workflows/${documentId}/versions`,
    getStatistics: (documentId) => `${API_BASE_URL}/workflows/${documentId}/statistics`,
    // Add more as needed
  },

  protocolRegistration: {
    usdm: (projectId) => `${API_BASE_URL}/protocol-registration/usdm/${projectId}`,
    registerUsdm: (projectId) => `${API_BASE_URL}/protocol-registration/usdm/${projectId}/register`,
    publishExternalSdr: (projectId) => `${API_BASE_URL}/protocol-registration/usdm/${projectId}/publish-external-sdr`,
    validateExternalSdrUpload: (projectId) =>
      `${API_BASE_URL}/protocol-registration/usdm/${projectId}/validate-external-sdr-upload`,
    externalSdrDownload: (projectId, studyId) =>
      `${API_BASE_URL}/protocol-registration/usdm/${projectId}/external-sdr-download${studyId ? `?studyId=${encodeURIComponent(studyId)}` : ''}`,
    // Enriched SoA endpoint — footnoteId/footnoteDescription correctly populated from local USDM
    // (SDR's own /studydesigns/soa does NOT map Activity.notes → footnoteId)
    soa: (projectId, studyId) =>
      `${API_BASE_URL}/protocol-registration/usdm/${projectId}/soa${studyId ? `?studyId=${encodeURIComponent(studyId)}` : ''}`,
  },
  workflowGuidance: {
    get: (role = 'reviewer') =>
      `${API_BASE_URL}/workflow-guidance?role=${encodeURIComponent(role)}`,
    /** Proxied API route — use public /guidance/*.pdf in UI iframe when possible */
    pdf: `${API_BASE_URL}/workflow-guidance/pdf`,
  },
  // ... other endpoints ...
}; 

export default API_ENDPOINTS; 